import React from 'react';
import { asyncComponent } from '@jaredpalmer/after';
// import Home from './containers/Home';

export default [
  {
    path: '/*',
    // exact: true,
    // component: Home,
    component: asyncComponent({
      loader: () => import('./containers/Content'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
];
